import { useParams } from 'react-router-dom';

const DRAFT_PREFIX = 'new-';

export const isDraftId = (id?: string) => Boolean(id?.startsWith(DRAFT_PREFIX));

export const getRealId = (id?: string) => (isDraftId(id) ? id?.slice(DRAFT_PREFIX.length) : id);

export const useDocumentId = () => {
  const { id } = useParams<{ id?: string }>();

  const isDraft = isDraftId(id);

  return {
    isDraft,
    rawId: id,
    id: getRealId(id),
  };
};
